import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

@Component({
  selector: 'login-tabs',
  template: require('./login-tabs.component.html')
})
export class LoginTabsComponent implements OnInit {
  @Input() registrationMode: any;
  @Input() siteConfig: any;

  useSSO: boolean = false;
  activeTab: string = 'login';

  constructor(
    private stateService: StateService
  ) {}

  ngOnInit(): void {
    this.useSSO = _.get(this.siteConfig, 'authenticationMode', 'db') === 'sso';
    const currentState = this.stateService.current.name;
    this.activeTab = currentState.includes('register') ? 'register' 
      : currentState.includes('lostpassword') ? 'lostpassword'
      : 'login';
  }
}
